import React, { useState, useEffect } from "react";
import { People } from "../../compilers/people";
import { useTranslation } from "react-i18next";
import "../../stylesheet/components/people/PeopleCard.scss";
//import { LocalisedPeople } from "../../compilers/LocalisedPeople";

interface person {
  media: People;
}

const PeopleCard: React.FC<person> = ({ media }) => {
  const { i18n } = useTranslation();
  const [langIndex, setLanguageIndex] = useState(0);
  useEffect(() => {
    if (i18n.language === "en") setLanguageIndex(0);
    if (i18n.language === "ar") setLanguageIndex(1);
  });

  // console.log(LinkedinLogo);

  const getImage = () => {
    let imgSrc = "/img/ze-people-placeholder.png";
    if (media.data.people[langIndex].image) {
      imgSrc = media.data.people[langIndex].image;
    }
    return (
      <img
        src={imgSrc}
        alt="profile-image"
        loading="lazy"
        className="profile-image"
      />
    );
  };

  const getLinkedInProfile = () => {
    if (media.data.people[langIndex].linkedin) {
      return (
        <a
          target="_blank"
          href={media.data.people[langIndex].linkedin}
          className="profile-card__share-container"
        >
          <img className="icon" src="/linkedin-logo.svg" alt="Linkedin Logo" />
        </a>
      );
    } else {
      return;
    }
  };

  const getProfileDetails = () => {
    return (
      <>
        <div className="profile-card__img-container">{getImage()}</div>
        <div className="profile-card__text-container">
          <h4 className="profile-name">{media.data.people[langIndex].name}</h4>
          <div className="profile-role">
            <p className="p2">{media.data.people[langIndex].jobTitle}</p>{" "}
          </div>
        </div>
      </>
    );
  };

  return (
    <div
      className={`card shadow-sm profile-card ${
        media.data.people[langIndex].linkedin !== "" ? "with-linkedin" : ""
      }`}
    >
      {media.data.people[langIndex].linkedin !== "" ? (
        // If there LinkedIn => The card will be a link
        <a
          className="profile-card__link"
          target="_blank"
          href={media.data.people[langIndex].linkedin}
        >
          {getProfileDetails()}
        </a>
      ) : (
        // If there is no LinkedIn => The card will be just a block
        <div className="profile-card__link">{getProfileDetails()}</div>
      )}
      {getLinkedInProfile()}
    </div>
  );
};

export default PeopleCard;
